import React, { Component } from 'react';
import { connect } from 'react-redux';
import { message } from 'antd';
import { Form } from '@ant-design/compatible';
import { balanceActions } from '../../store/modules/balance';
import BalanceDetailWrap from '../../views/balance/detail/BalanceDetailWrap';
import {
  UPDATE_BALANCE_CONFIRM_MESSAGE_TYPE,
  UPDATE_BALANCE_CONFIRM_MESSAGE,
} from '../../constants/service/app/balanceConstants';
import { asyncSimpleModal } from '../../lib/common';

class BalanceDetailContainer extends Component {
  componentDidMount() {
    this.initiate();
  }

  initiate = () => {
    const { balanceId, getBalanceDetail } = this.props;
    getBalanceDetail({ balanceId });
  };

  /**
   *  편집하기
   */
  editBalance = (data) => {
    const { msgType, targetStatus = null } = data;
    const { form, editBalanceDetail, balanceDetail } = this.props;
    const { balanceInfo } = balanceDetail;

    form.validateFields(async (err) => {
      if (err) return;

      /**
       *  정산처리인 경우에는 정산 예정 금액과 정산 집행 금액이 같아야만 처리가능
       */
      if (
        msgType === UPDATE_BALANCE_CONFIRM_MESSAGE_TYPE.EXECUTION &&
        balanceInfo.paidBalance !== balanceInfo.finalBalance
      ) {
        message.error('정산 집행 금액과 정산 집행금액이 같아야 합니다.');
        return;
      }

      const confirmResult = await asyncSimpleModal({
        type: 'confirm',
        title: UPDATE_BALANCE_CONFIRM_MESSAGE[msgType].title,
        message: UPDATE_BALANCE_CONFIRM_MESSAGE[msgType].message,
      });

      if (!confirmResult) return;

      editBalanceDetail({
        /**
         *  정산번호
         */
        balanceId: balanceInfo.balanceId,
        /**
         *  정산상태
         */
        targetStatus,
        /**
         *  은행명
         */
        bankName: balanceInfo.bankName,
        /**
         *  예금주
         */
        accountHolder: balanceInfo.accountHolder,
        /**
         *  계좌번호
         */
        accountNumber: balanceInfo.accountNumber,
        /**
         *  정산 집행 금액
         */
        paidBalance: balanceInfo.paidBalance,
        /**
         *  정산 보류 금액
         */
        holdBalance: balanceInfo.holdBalance,
        /**
         *  정산 추가 금액
         */
        extraBalance: balanceInfo.extraBalance,
        /**
         *  메모
         */
        memo: balanceInfo.memo,
      });
    });
  };

  render() {
    const { form, setData, balanceDetail } = this.props;

    return (
      <BalanceDetailWrap form={form} setData={setData} balanceDetail={balanceDetail} editBalance={this.editBalance} />
    );
  }
}

const mapStateToProps = (state) => {
  return {
    balanceDetail: state.balance.balanceDetail,
  };
};

const mapDispatchToProps = {
  setData: balanceActions.setData,
  getBalanceDetail: balanceActions.getBalanceDetail,
  editBalanceDetail: balanceActions.editBalanceDetail,
};

export default connect(mapStateToProps, mapDispatchToProps)(Form.create()(BalanceDetailContainer));
